var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMobile
    ? _c(
        "rb-panel",
        {
          attrs: { visible: _vm.afterpayIsVisible },
          on: { closed: _vm.closeAfterpay },
        },
        [_c("rb-afterpay-panel")],
        1
      )
    : _c("rb-afterpay-modal", {
        attrs: {
          "afterpay-is-visible": _vm.afterpayIsVisible,
          prices: _vm.prices,
        },
        on: { closed: _vm.closeAfterpay },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }